'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = function () {
	return function (session, instance) {
		if (!session) {
			return '';
		}

		var color;

		if (session.overwriteColor && instance in session.overwriteColor) {
			color = session.overwriteColor[instance];
		} else {
			color = session.color;
			var i;
			if (_typeof(session.overwriteFromHere) === 'object') {
				for (i = 0; i <= instance; i++) {
					color = session.overwriteFromHere[i] || color;
				}
			}
		}

		return color;
	};
};


// WEBPACK FOOTER //
// ./client/components/misc-services/color-finder.js